// extracted by mini-css-extract-plugin
export default {"submitFooter":"_1DVlt___FormSubmitter-module__submitFooter"};